import { supabase } from '../lib/supabase';

export const clientService = {
  // Get all clients
  async getClients() {
    try {
      const { data, error } = await supabase
        ?.from('clients')
        ?.select(`
          *,
          created_by:user_profiles(id, full_name, email)
        `)
        ?.order('created_at', { ascending: false });
      
      if (error) {
        return { clients: [], error: error?.message };
      }
      
      return { clients: data || [], error: null };
    } catch (error) {
      if (error?.message?.includes('Failed to fetch') || 
          error?.message?.includes('NetworkError')) {
        return { 
          clients: [], 
          error: 'Cannot connect to database. Your Supabase project may be paused or deleted. Please visit your Supabase dashboard to check project status.' 
        };
      }
      return { clients: [], error: 'Failed to load clients.' };
    }
  },

  // Get client by ID
  async getClient(id) {
    try {
      const { data, error } = await supabase
        ?.from('clients')
        ?.select(`
          *,
          created_by:user_profiles(id, full_name, email),
          quotes(id, quote_number, status, total_price, created_at)
        `)
        ?.eq('id', id)
        ?.single();
      
      if (error) {
        return { client: null, error: error?.message };
      }
      
      return { client: data, error: null };
    } catch (error) {
      if (error?.message?.includes('Failed to fetch') || 
          error?.message?.includes('NetworkError')) {
        return { 
          client: null, 
          error: 'Cannot connect to database. Your Supabase project may be paused or deleted. Please visit your Supabase dashboard to check project status.' 
        };
      }
      return { client: null, error: 'Failed to load client.' };
    }
  },

  // Create new client
  async createClient(clientData) {
    try {
      const { data, error } = await supabase
        ?.from('clients')
        ?.insert([clientData])
        ?.select()
        ?.single();
      
      if (error) {
        return { client: null, error: error?.message };
      }
      
      return { client: data, error: null };
    } catch (error) {
      if (error?.message?.includes('Failed to fetch') || 
          error?.message?.includes('NetworkError')) {
        return { 
          client: null, 
          error: 'Cannot connect to database. Your Supabase project may be paused or deleted. Please visit your Supabase dashboard to check project status.' 
        };
      }
      return { client: null, error: 'Failed to create client.' };
    }
  },

  // Update client
  async updateClient(id, updates) {
    try {
      const { data, error } = await supabase
        ?.from('clients')
        ?.update(updates)
        ?.eq('id', id)
        ?.select()
        ?.single();
      
      if (error) {
        return { client: null, error: error?.message };
      }
      
      return { client: data, error: null };
    } catch (error) {
      if (error?.message?.includes('Failed to fetch') || 
          error?.message?.includes('NetworkError')) {
        return { 
          client: null, 
          error: 'Cannot connect to database. Your Supabase project may be paused or deleted. Please visit your Supabase dashboard to check project status.' 
        };
      }
      return { client: null, error: 'Failed to update client.' };
    }
  },

  // Delete client
  async deleteClient(id) {
    try {
      const { error } = await supabase
        ?.from('clients')
        ?.delete()
        ?.eq('id', id);
      
      if (error) {
        return { error: error?.message };
      }
      
      return { error: null };
    } catch (error) {
      if (error?.message?.includes('Failed to fetch') || 
          error?.message?.includes('NetworkError')) {
        return { 
          error: 'Cannot connect to database. Your Supabase project may be paused or deleted. Please visit your Supabase dashboard to check project status.' 
        };
      }
      return { error: 'Failed to delete client.' };
    }
  },

  // Search clients
  async searchClients(searchTerm) {
    try {
      const { data, error } = await supabase
        ?.from('clients')
        ?.select(`
          *,
          created_by:user_profiles(id, full_name, email)
        `)
        ?.or(`first_name.ilike.%${searchTerm}%,last_name.ilike.%${searchTerm}%,email.ilike.%${searchTerm}%`)
        ?.order('created_at', { ascending: false });
      
      if (error) {
        return { clients: [], error: error?.message };
      }
      
      return { clients: data || [], error: null };
    } catch (error) {
      if (error?.message?.includes('Failed to fetch') || 
          error?.message?.includes('NetworkError')) {
        return { 
          clients: [], 
          error: 'Cannot connect to database. Your Supabase project may be paused or deleted. Please visit your Supabase dashboard to check project status.' 
        };
      }
      return { clients: [], error: 'Failed to search clients.' };
    }
  }
};

export default clientService;